export default __webpack_public_path__ + "static/media/StarLight.0256e77a.png";